import type { LocalizedString } from '@protector/utils/types';
import { z } from 'zod';

export const cropSchema = z.object({
  id: z.string(),
  name: z.string(),
  wk_slug: z.string().nullable().optional()
});

export const localizedNameSchema = z.object({
  language: z.string(),
  name: z.string()
});

const localizedCropSchema = z.object({
  id: z.string(),
  location: z.string(),
  default_crop_zone_duration: z.number().optional(),
  default_growth_scale_id: z.string().optional(),
  default_growth_scale_name: z.string().optional(),
  deleted_at: z.string().nullable()
});

export const cropCatalogSchema = z.object({
  id: z.string(),
  name: z.array(localizedNameSchema),
  image_url: z.string(),
  icon: z.string(),
  specialization_type: z.string(),
  label: z.string(),
  scientific_name: z.string(),
  parent_id: z.string().nullable(),
  eppo_code: z.string(),
  localized_crops: z.array(localizedCropSchema),
  deleted_at: z.string().nullable(),
  image_url_ref: z.string()
});

export const cropCatalogPageSchema = z.object({
  content: z.array(cropCatalogSchema),
  number: z.number().optional(),
  total_pages: z.number().optional(),
  total_elements: z.number().optional()
});

const developmentPhasesSchema = z.object({
  id: z.string(),
  crop_id: z.string(),
  days_after_emergency: z.number(),
  duration_in_days: z.number(),
  type: z.string(),
  is_canonical: z.boolean(),
  created_at: z.string(),
  modified_at: z.string(),
  deleted_at: z.string().nullable().optional(),
  description: z.custom<LocalizedString>().optional(),
  name: z.custom<LocalizedString>().optional(),
  localized_instruction: z.custom<LocalizedString>().optional()
});

const varietySchema = z.object({
  id: z.string(),
  name: z.string(),
  manufacturer: z.string().nullable(),
  vendorId: z.string().nullable().optional(),
  companyId: z.string().nullable().optional(),
  unitOfMeasure: z.string(),
  deleted: z.boolean(),
  lastPrice: z.number().nullable().optional(),
  productType: z.string(),
  hide: z.boolean().optional()
});

export const cropResponseSchema = z.object({
  id: z.string(),
  name: z.custom<LocalizedString>().optional(),
  company_id: z.string(),
  varieties: z.array(varietySchema).optional(),
  wk_slug: z.string().optional(),
  wkSlug: z.string().optional(),
  development_phases: z.array(developmentPhasesSchema).optional()
});

export const cropListResponseSchema = z.object({
  content: z.array(cropResponseSchema),
  number: z.number().optional(),
  total_pages: z.number().optional(),
  total_elements: z.number().optional()
});
